import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  Flex,
  Heading,
  Box,
  Text,
  UnorderedList,
  OrderedList,
  Button,
  List,
  ListItem,
  SimpleGrid,

} from "@chakra-ui/react";

import { useLocation } from "react-router-dom";
import { Waypoint } from "react-waypoint";
import { Link, NavLink } from "react-router-dom";

//images
import bg from "../../assets/images/Logobg.jpeg";

const area1 = require("../../assets/images/Deep_water_FlowAssurance5.jpeg");
const area2 = require("../../assets/images/Process_Engineering_Aspen_HYSYS.jpeg");
const area3 = require("../../assets/images/Drafting3.jpeg");

const ServiceSection = ({ title, items }) => (
  <Box
  
    borderWidth="1px"
    borderRadius="2xl"
     borderWidth="3px"
    borderStyle="solid"
   
    borderColor="rgb(236, 24, 24)"
    bg={"black"}
    color={"whiteAlpha.900"}
    p={{base:6, md:8}}
    shadow="sm"
    _hover={{ shadow: "md" }}
    transition="0.3s"
  >
    <Heading fontSize={{base:"22px", "3sm":"22px", lg: "24px"}} p={{base:"0", md:8}}>
      {title}
    </Heading>

    <List spacing={2} styleType="disc" stylePosition="outside" mt={{base:4,md:0}} ml={{base:6, md:16}} >
      {items.map((item, index) => (
        <ListItem key={index} color={"whiteAlpha.900"} fontSize={{base:"18px", "3sm":"18px", lg:"20px"}} pl={2}>
          {item}
        </ListItem>
      ))}
    </List>
  </Box>
);

const items = [
  "Data Collection & Review",
  "Simulation Model Development",
  "Steady-State & Transient Analysis",
  "Result Evaluation",
  "Engineering Recommendations"
];

const Business = () => {
  let params = useLocation();
  useEffect(() => {
    if (params?.state?.id)
      document.querySelector(`${params.state.id}`).scrollIntoView(true);
    else window.scrollTo(0, 0);
  }, [params.state, useLocation().state]);

  return (
    <Flex flexDir={"column"} alignItems={"center"}>
      <Helmet>
        <html lang="en" />

        <title>
          Flow Assurance & Process Engineering Services | AKIA Flow Assurance
        </title>

        <meta
          name="description"
          content="Explore specialized engineering services including OLGA simulation, PIPESIM studies, surge analysis, hydrate studies, wax deposition analysis, process simulation, flare studies, and hydraulic calculations."
        />

        <meta
          name="keywords"
          content="Flow Assurance Services, Process Engineering Services, OLGA Simulation, PIPESIM Analysis, Aspen HYSYS, Surge Analysis, Hydrate Study, Wax Study, Process Simulation, Flare System Hydraulics"
        />

        <meta name="author" content="AKIA Flow Assurance" />
        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="Flow Assurance & Process Engineering Services"
        />

        <meta
          property="og:description"
          content="Simulation-driven engineering support for pipelines, production systems, and process facilities."
        />

      <link rel="canonical" href="https://akiaflowassurance.com/business" />

      </Helmet>
      <Flex
        bg={`linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)), url(${bg})`}
        backgroundSize={"cover"}
        backgroundPosition={"bottom"}
        h={"100vh"}
        w="100vw"

        minH="100vh"
        color={"whiteAlpha.900"}
        flexDirection={"column"}

        alignItems="flex-start"
        justifyContent="center"

        
        pl={{ base: "", md: "30rem", lg: "80rem" }}
      >


        <Box
          width={"fit-content"}
          transform={{
            base: "",
            md: "translateX(-10vw)",
            lg: "translateX(-15vw)",
          }}
          px={"4rem"}
        >
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain5").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain5">
                <Heading
                                  flexShrink={"0"}
                                  textTransform={"uppercase"}
                                  fontSize={{ base: "3.0rem", "3sm": "4.5rem", lg: "5.0rem" }}
                                  maxW={"100rem"}
                                  color={"whiteAlpha.900"}
                                  fontFamily={"Roboto Condensed, Lato, sans-serif"}
                                  textAlign="center"
                
                                  w={"100%"}
                                >
                  Our Services
                </Heading>
                <Box
                  w={"100%"}
                  h={"100%"}
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                />
              </Flex>
            </Waypoint>
          </Flex>
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
            mt={"1rem"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain4").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain4">
                <Text
                  textAlign={{ base: "left", md: "left" }}
                  fontSize={{ base: "1.8rem", md: "2rem" }}
                  maxW={"100rem"}
                  flexShrink={"0"}
                  w={"100%"}
                  minW={"30rem"}
                  
                >



                  We offer Specialized engineering studies and consulting in:
                  <UnorderedList>
                    <ListItem>Flow Assurance Engineering</ListItem>
                    <ListItem>Process Engineering Support</ListItem>
                  </UnorderedList>
                </Text>
                <Box
                  w={"100%"}
                  h={"100%"}
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                />
              </Flex>
            </Waypoint>
          </Flex>
        </Box>
      </Flex>

      {/* Next Section */}




      <Flex
        width={"100%"}
        px={{ base: "2rem", "3sm": "5rem", lg: "8rem" }}
        py={{ base: "5rem", md: "5rem", lg: "5rem" }}
        flexDir={"column"}
        align="center"        // vertical center ✅
        justify="center"      // horizontal center ✅


      >


        <Flex
          flexDir={{ base: "column-reverse", md: "column-reverse"}}
          gap={{ base: "2rem", lg: "2rem" }}
          width={"100%"}
          mt={"2rem"}
          maxW={"1440px"}
        >
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
          >
            <Flex
              overflow={"hidden"}
              maxW={"100rem"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >
              <Waypoint
                onEnter={() =>
                (document.querySelector("#flow").style.animation =
                  "heading 1.5s ease")
                }
              >
                <Flex id="flow">



                  <Heading
                    width={"100%"}
                    textTransform={"uppercase"}
                    flexShrink={0}
                    fontSize={{ base: "2.5rem", md: "3rem" }}
                    mb={"1.5rem"}
                  >
                    Flow Assurance
                  </Heading>
                  <Box w={"100%"}  bg={"black"} flexShrink={"0"} />

                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"}  h="5px" w={"6rem"} mb={"1.0rem"}></Box>

            <Text fontSize={["1.8rem","1.8rem", "1.8rem", "2rem"]} mt={"1rem"} textAlign={"justify"}>
              Flow assurance engineering focuses on ensuring the safe, reliable, and efficient transport of oil, gas, and water through pipelines and production systems. We perform steady-state and transient studies to evaluate flow behavior, hydraulic performance, thermal effects, operational risks, and pipeline integrity under varying operating conditions.
            </Text>

            <SimpleGrid mt={6} columns={[1, 1,1, 2]} spacing={6}>
              <ServiceSection
                title="Multiphase Flow Analysis"
                items={[
                  "Well fluid analysis",
                  "Multiphase pipeline hydraulic Analysis",
                  "Production system modeling and optimization",
                   "Flow regime and slugging analysis",
                  "Pressure drop and liquid holdup prediction",
                  "Start-up, shutdown, and pigging analysis",
                  "Pressure envelope evaluation",
                  


                ]}
              />

              <ServiceSection
                title="Single-Phase Pipeline Analysis"
                items={[

                  "Hydraulic analysis of oil/gas pipelines",
                  "Surge analysis",
                  "Gas pipeline line packing simulations",
                  "Depressurization studies",
                  "Surge mitigation recommendations"


                ]}
              />

              <ServiceSection
                title="Flow Assurance Risk Assessment"
                items={[
                  "Heat loss and temperature profiling",
                  "Hydrate risk assessment",
                  "Wax deposition studies",
                  "MEG and methanol injection rate calculations"

                ]}
              />





              <ServiceSection
                title="Injection System Analysis"
                items={[
                  "Water injection network hydraulic analysis",
                  "Gas injection network hydraulic analysis",
                  "Pump sizing and performance evaluation",

                  "Compressor operating envelope evaluation"

                ]}
              />
            </SimpleGrid>

            {/* Tools */}
           


<Flex
        flexDir={{ base: "column-reverse", md: "column-reverse" }}
        
        width={"100%"}
       
        maxW={"1440px"}
      >
        <Flex
          flexDirection={"column"}
          flex={"0 1 50%"}
          justifyContent={"center"}
        >
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
            mb={"1.5rem"}
          >


            <Waypoint
              onEnter={() =>
              (document.querySelector("#approach").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="approach">
                <Heading width={"100%"}
                  textTransform={"uppercase"}
                  flexShrink={0}
                 pt={{ base: "2rem", "3sm": "2rem" ,lg:"4rem"}}
                  fontSize={{base:"2.5rem", md:"3rem"}}
                  mb={"1.5rem"}>
                  Our Approach
                </Heading>
                <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
              </Flex>
            </Waypoint>
          </Flex>
      

          {/* Grid Sections */}


          <SimpleGrid bg={"black"} mt={2} columns={[1, 1,1, 2]} borderRadius="2xl" spacing={8} borderWidth="3px"
  borderStyle="solid"
  borderColor="rgb(236, 24, 24)"
 

     pl={8}>



            <OrderedList spacing={4} mt={6} mb={6} >
              {items.map((item, index) => (
                <ListItem

                  key={index}
                  color={"whiteAlpha.900"}
                  fontSize={["1.8rem","1.8rem", "1.8rem", "2rem"]}
                  pl={4}
                 
                >
                  {item}
                </ListItem>
              ))}
            </OrderedList>



          </SimpleGrid>
           <Box as="span" fontWeight="bold"   pt={{ base: "2rem", "3sm": "2rem" ,lg:"4rem"}}
                  fontSize={{base:"2.5rem", md:"3rem"}}>
                  CASE STUDIES
                  </Box><br />
                  <Waypoint
                    onEnter={() =>
                    (document.querySelector("#animate7").style.animation =
                      "fadeUp 1.5s")
                    }
                  >
                    <NavLink to={{ pathname: "/CaseStudies" }}>
                      <Button
                        id="animate7"
                        bg={"#EA0F0F"}
                        color={"whiteAlpha.900"}
                        borderRadius={"md"}
                       
                        fontSize="2rem"
                        fontWeight={700}
                        width={200}
                        p={"2.0rem 2rem"}
                        textTransform={"uppercase"}
                        outline={"3px solid #fa0505ee"}
                        outlineOffset={"5px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          outlineOffset: "0px",
                        }}
                      >
                        View Case Studies
                      </Button>
                    </NavLink>
                  </Waypoint>

 <Box mt={10}>
               <Text fontWeight="bold" fontSize={{base:"2.5rem", md:"3rem"}}>SOFTWARE TOOLS</Text>
              <Text fontSize={{base:"1.8rem", md:"2.5rem"}}color="gray.900">OLGA | PIPESIM | PIPENET | PVTSim</Text>
            </Box>

        </Flex>


      </Flex>








          </Flex>
          <Waypoint
            onEnter={() =>
            (document.querySelector("#animate22").style.animation =
              "fadeUp 1.5s")
            }
          >




            <Box
              id="animate22"
              mt={{base:"0rem", "3sm":"5rem", lg:"9rem"}}
              flex={{ base: "0 1 200px", md: "0 1 50%" }}
              bg={`url(${area1})`}
              bgPos={"center"}
              backgroundSize={{ base: "contain", md: "cover" }}
            
                backgroundRepeat="no-repeat"
              height={{base:"200px", "3sm":"600px", lg:"600px"}}
              borderRadius="2xl"
              h="100%"
              minH={{base:"200px", "3sm":"800px", lg:"800px"}}
            ></Box>

          </Waypoint>
        </Flex>
      
               

        <Flex
          flexDir={{ base: "column-reverse", md: "column-reverse" }}
          gap={{ base: "2rem", lg: "2rem" }}
          width={"100%"}
          mt={"2rem"}
          maxW={"1440px"}
        >
          <Flex
            flexDirection={"column"}
            flex={"0 1 50%"}
            justifyContent={"center"}
          >
            <Flex
              overflow={"hidden"}
              maxW={"100rem"}
              pos={"relative"}
              overflowX={"hidden"}
              w={"fit-content"}
              mb={"1.5rem"}
            >


              <Waypoint
                onEnter={() =>
                (document.querySelector("#process").style.animation =
                  "heading 1.5s ease")
                }
              >





                <Flex id="process">
                  <Heading width={"100%"}
                    textTransform={"uppercase"}
                    flexShrink={0}
                    fontSize={{ base: "2.5rem", md: "3rem" }}
                    mb={"1.5rem"}
                    mt={{ base: "", "3sm": "2rem" ,lg:"4rem"}}>
                    Process Engineering Support
                  </Heading>
                  
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.0rem"}></Box>
            <Text fontSize={{ base: "1.8rem", md: "2rem" }} mt={"1rem"} textAlign={"justify"}>

              We provide process engineering support for oil & gas production facilities, pipeline systems, and utility networks, covering conceptual studies, FEED support studies, process optimization, and hydraulic system evaluations.

            </Text>

            {/* Grid Sections */}
            <SimpleGrid mt={6} columns={[1, 1, 1, 3]} spacing={8}>

              <ServiceSection
                title="Process System "
                items={[
                  
                  "Aspen HYSYS Process Simulation",
                  "Debottlenecking Studies",
                  "Process Optimization",
                  "Operating Envelope Assessment",
                  "Conceptual Process Studies",
                  "FEED Support Studies",
                   "Process Equipment & System Evaluation",
                                  
                ]}
              />

              

    <ServiceSection
                title="Flare System "
                items={[
                  
                 "Flare and Relief System Hydraulic Analysis",
                  "Blowdown and Depressurization Studies"
                                  
                ]}
              />
 <ServiceSection
                title="Utility  System "
                items={[
                  
                 

                  "Utility System Studies (Hydraulic & Capacity Analysis)",

                  "Water Network Analysis (Potable, Cooling, Fire & Treated Water Systems)"
                                  
                ]}
              />
            </SimpleGrid>

            {/* Tools Section */}

            < Box mt={6}>
              <Text fontWeight="bold" fontSize={{base:"2.5rem", md:"3rem"}}>SOFTWARE TOOLS</Text>
              <Text fontSize={{base:"1.8rem", md:"2.5rem"}}color="gray.900">
                Aspen HYSYS | FLARENET | WaterCAD | EPANET
              </Text>
            </Box>


          </Flex>
          <Waypoint
            onEnter={() =>
            (document.querySelector("#animate16").style.animation =
              "fadeUp 1.5s")
            }
          >

            <Box
              id="animate16"
              mt={{ base: "2rem","3sm": "5rem", lg: "12rem" }}
              flex={{ base: "0 1 200px", md: "0 1 50%" }}
              bg={`url(${area2})`}
              bgPos={"center"}
              backgroundSize={{ base: "contain", md: "cover" }}
                backgroundRepeat="no-repeat"
              borderRadius="xl"
              h="100%"
              width={"100%"}
             minH={{base:"200px", "3sm":"800px", lg:"800px"}}
            ></Box>
          </Waypoint>
        </Flex>


        </Flex>

      



      <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.2rem", md: "2.5rem" }}
        >
          Connect with us
        </Heading>
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>
          <a
                      id="phone"
                      style={{ flex: "0 0 22%" }}
                      href="https://wa.me/+971501232838"
                    >
                      
                        <Heading fontSize={"4rem"}>
                          <i
                            className="fa-brands fa-square-whatsapp"
                            style={{ color: "green" }}
                          />
                        </Heading>
                        
                        
                      
                    </a>
             <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Business;
